import { V as VuesticIconFonts } from "./presets/fonts.js";
import { V as VuesticIconAliases } from "./presets/vuestic-aliases.js";
const createIconsConfig = (config) => {
  config.aliases = config.aliases || [];
  config.fonts = config.fonts || [];
  return [
    ...config.aliases,
    ...VuesticIconAliases,
    ...config.fonts,
    ...VuesticIconFonts
  ];
};
export { createIconsConfig as c };
//# sourceMappingURL=create-icons-config.js.map
